import React, { useContext, useEffect, useRef, useState } from 'react'
import { GrMenu } from 'react-icons/gr'
import { IoIosCloseCircleOutline, IoIosSearch } from 'react-icons/io'
import InputGroup from '../../components/Input/InputGroup'
import { IoFilterSharp } from 'react-icons/io5'
import SuperAdminContext from '../../hooks/SuperAdminContext'
import SuperAdminPagination from './Resuable_Comp/SuperAdminPagination'
import images from '../../utils/images'
import Button from '../../components/Button/Button'
import SuperAdminJobFilter from './Resuable_Comp/SuperAdminJobFilter'
import JobCard from '../../components/Cards/JobCard'
import JobDetailView from './Resuable_Comp/JobDetailView'
import toast from 'react-hot-toast'
import { MdClear } from 'react-icons/md'
import { handleReset } from 'Actions/commonAction/milleSearchFilterActions'
import { useDispatch, useSelector } from 'react-redux'
import { createSelector } from '@reduxjs/toolkit'
import { reset_all_states_to_default } from 'Slices/commonSlices/milleSearchFilter'

const SuperAdminJobs = () => {
    //Redux slice picker
    const selectmilleSearchStates = (state) => state.milleSearchStates;
    const selectMemoizedStates = createSelector(
        [selectmilleSearchStates],
        (milleSearchStates) => ({ milleSearchStates })
    );

    const { milleSearchStates } = useSelector(selectMemoizedStates);
    //

    const containerRef = useRef(null);
    const dispatch = useDispatch();

    const {
        currentPage,
        initialGlow, setMinimumDeviceCards,
        getJobDashboard,
        employerJobDetailsDupli,
        selectedJobCard, employerJobType,
        employerJobLocation, employerJobSchedule,
        employerJobSector, employerJobSkill,
        employerJobSpeci, employerJobWorkplace,
        paginationTotalCount, setCurrentPage,
        jobApplyFilterLoading, setSkillss,
        setSectors, setSpecialization,
        setWorkplaceType,
        setJobTypee, setSchedule,
        initializeReset,
        employerOpen, setEmployerOpen,
        setEmployerJobLocation,
        setEmployerJobSector,
        setEmployerJobSkill,
        setEmployerJobSpeci,
        setInitialglow,
        superAdminJobSearch, setsuperAdminJobSearch,
        setjobsSortBy, isMilleSearchFiltered, setIsMilleSearchFiltered,
        setIsSearched, skillss, sectors,
        specialization, jobStatusSelect,
        workplaceType, jobTypee, schedule,
        mellieSearchJobPlans, setjobApplyFilterObject,
        handleAdminJobslMeilisearch, setApplyFilterCount,
        isSearched

    } = useContext(SuperAdminContext);

    const [sortBy, setSortBy] = useState('Date Latest');
    const a = [1, 2, 3, 4, 5, 6, 7];

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const jobID = queryParams.get("job_id");
        if (jobID) {
            selectedJobCard(jobID)
            getJobDashboard(undefined, undefined, undefined, jobID);
            var uri = window.location.toString();
            if (uri.indexOf("?") > 0) {
                var clean_uri = uri.substring(0, uri.indexOf("?"));
                window.history.replaceState({}, document.title, clean_uri);
            }
        } else {
            getJobDashboard();
        }

        setSkillss([]);
        setSectors([]);
        setSpecialization([]);
        setWorkplaceType([]);
        setJobTypee([]);
        setSchedule([]);
        dispatch(handleReset())

        setInitialglow(true);
        setCurrentPage(0);
        setMinimumDeviceCards(false);
        setSortBy("Date Latest")
        setjobsSortBy("");

        setIsMilleSearchFiltered(false)
        setIsSearched(false)
    }, [])

    useEffect(() => {
        if (containerRef.current) {
            containerRef.current.scrollTop = 0;
        }
    }, [employerJobDetailsDupli])

    const handleSortingFilter = (sortValue) => {
        setSortBy(sortValue)
        setIsSearched(false)
        setIsMilleSearchFiltered(false)

        initializeReset()
        dispatch(reset_all_states_to_default())

        switch (sortValue) {
            case "Date Latest":
                setjobsSortBy('')
                getJobDashboard();
                setCurrentPage(0);
                break;

            case "Date Oldest":
                setjobsSortBy('by_date')
                getJobDashboard(undefined, undefined, 'by_date');
                setCurrentPage(0);
                break;


            case "A-Z":
                setjobsSortBy('asc')
                getJobDashboard(undefined, undefined, 'asc');
                setCurrentPage(0);
                break;

            case "Z-A":
                setjobsSortBy('desc')
                getJobDashboard(undefined, undefined, 'desc');
                setCurrentPage(0);

                break;
            default:
                break;
        }
    }

    const handlekeydown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            if (superAdminJobSearch) {
                setSortBy("Date Latest")
                setjobsSortBy("");
                setCurrentPage(0)
                setIsSearched(true)

                var a = skillss.map((v) => v.label)
                var b = sectors.map((v) => v.label)
                var c = specialization.map((v) => v.label)
                var e = mellieSearchJobPlans.map((v) => v.label)
                var jobStatus = jobStatusSelect.map((v) => v.send_data_to_api)

                const locationConvertion = milleSearchStates?.location.map((v) => {
                    const originalVal = v.split(',')
                    const joinOriginalValue = originalVal.join('&&&&&')

                    return joinOriginalValue
                })

                let object;
                if (isMilleSearchFiltered) {
                    object = {
                        skills: a,
                        sector: b,
                        specialisation: c,
                        workplace_type: workplaceType,
                        location: locationConvertion,
                        job_type: jobTypee,
                        work_schedule: schedule,
                        plan: e[0] === "All" ? [] : e,
                        job_status: jobStatus[0] === "All" ? [] : jobStatus,
                        search_text: superAdminJobSearch
                    }
                } else {
                    object = {
                        skills: [],
                        sector: [],
                        specialisation: [],
                        workplace_type: [],
                        location: [],
                        job_type: [],
                        work_schedule: [],
                        plan: [],
                        job_status: [],
                        search_text: superAdminJobSearch
                    }
                }

                setjobApplyFilterObject(object)
                handleAdminJobslMeilisearch(object)
            } else {
                toast.error("search field is empty")
            }
        }
    };

    const handleSearchInput = (e) => {
        setsuperAdminJobSearch(e.target.value)
    }

    function clickSearchIcon() {
        setjobsSortBy('')
        setSortBy('Date Latest')
        setIsSearched(true)

        var a = skillss.map((v) => v.label)
        var b = sectors.map((v) => v.label)
        var c = specialization.map((v) => v.label)
        var e = mellieSearchJobPlans.map((v) => v.label)
        var jobStatus = jobStatusSelect.map((v) => v.send_data_to_api)

        const locationConvertion = milleSearchStates?.location.map((v) => {
            const originalVal = v.split(',')
            const joinOriginalValue = originalVal.join('&&&&&')

            return joinOriginalValue
        })

        let object;
        if (isMilleSearchFiltered) {
            object = {
                skills: a,
                sector: b,
                specialisation: c,
                workplace_type: workplaceType,
                location: locationConvertion,
                job_type: jobTypee,
                work_schedule: schedule,
                plan: e[0] === "All" ? [] : e,
                job_status: jobStatus[0] === "All" ? [] : jobStatus,
                search_text: superAdminJobSearch
            }
        } else {
            object = {
                skills: [],
                sector: [],
                specialisation: [],
                workplace_type: [],
                location: [],
                job_type: [],
                work_schedule: [],
                plan: [],
                job_status: [],
                search_text: superAdminJobSearch
            }
        }

        setjobApplyFilterObject(object)
        handleAdminJobslMeilisearch(object)
    }

    function handle_clear_user_searches(clear_params) {
        setCurrentPage(0)
        if ((!isSearched && !isMilleSearchFiltered) || (clear_params === "search" && !isMilleSearchFiltered) || (clear_params === "clear filter" && !isSearched)) {
            if (clear_params === "search") {
                setIsSearched(false)
                setsuperAdminJobSearch('')
            }

            if (clear_params === "clear filter") {
                setIsMilleSearchFiltered(false)
                initializeReset()
                setApplyFilterCount(0);
                dispatch(reset_all_states_to_default())
            }

            getJobDashboard();
            return
        }

        let object;
        if (clear_params === "search") {
            setIsSearched(false)
            setsuperAdminJobSearch('')
            var a = skillss.map((v) => v.label)
            var b = sectors.map((v) => v.label)
            var c = specialization.map((v) => v.label)
            var e = mellieSearchJobPlans.map((v) => v.label)
            var jobStatus = jobStatusSelect.map((v) => v.send_data_to_api)

            const locationConvertion = milleSearchStates?.location.map((v) => {
                const originalVal = v.split(',')
                const joinOriginalValue = originalVal.join('&&&&&')

                return joinOriginalValue
            })

            if (isMilleSearchFiltered) {
                object = {
                    skills: a,
                    sector: b,
                    specialisation: c,
                    workplace_type: workplaceType,
                    location: locationConvertion,
                    job_type: jobTypee,
                    work_schedule: schedule,
                    plan: e[0] === "All" ? [] : e,
                    job_status: jobStatus[0] === "All" ? [] : jobStatus,
                    search_text: ""
                }
            } else {
                object = {
                    skills: [],
                    sector: [],
                    specialisation: [],
                    workplace_type: [],
                    location: [],
                    job_type: [],
                    work_schedule: [],
                    plan: [],
                    job_status: [],
                    search_text: ""
                }
            }
        } else {
            setIsMilleSearchFiltered(false)
            object = {
                skills: [],
                sector: [],
                specialisation: [],
                workplace_type: [],
                location: [],
                job_type: [],
                work_schedule: [],
                plan: [],
                job_status: [],
                search_text: isSearched ? superAdminJobSearch : ""
            }

            initializeReset()
            setApplyFilterCount(0);
            dispatch(reset_all_states_to_default())
        }

        setjobApplyFilterObject(object)
        handleAdminJobslMeilisearch(object)
    }

    return (
        <div className="col-12 col-xxl-10 superAdmin-rightSide-total-height overflow-hidden">
            <div className="col-12 superAdmin-rightSide-Component-name-height">
                <div className="container-fluid px-lg-4 h-100 shadow">
                    <div className="row align-items-center h-100 ">
                        <div className="col-6">
                            <h5>Jobs</h5>
                        </div>

                        <div className="col-6 text-end d-xxl-none">
                            <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#superAdminSidebar" aria-controls="superAdminSidebar">
                                <GrMenu className='fs-4' />
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-12 superAdmin-rightSide-Component-content-height placeholder-glow">
                <div className="container-fluid px-lg-4 h-100">
                    <div className="row h-100">
                        <div className="col-12 col-lg-4 h-100 py-3">
                            <div className="row superAdmin-professional-functions">
                                {/* search bar  */}
                                <div className="col-12 col-md-12 col-lg-12">
                                    {
                                        initialGlow ?
                                            <div className='placeholder w-100 rounded-2 py-3'></div>
                                            :
                                            <div className="d-flex position-relative">
                                                <InputGroup
                                                    className="home-search-icon fs-5"
                                                    reIcons={<IoIosSearch />}
                                                />

                                                <input
                                                    type="text"
                                                    className="form-control form-control-lg searchInput candidate-searchInput border-0 px-5 py-0 searchInput-border"
                                                    placeHolder="Search by job title, description, company name,location"
                                                    ariaLabel="default input example"
                                                    testId="searchResult"
                                                    value={superAdminJobSearch}
                                                    onChange={handleSearchInput}
                                                    onKeyDown={handlekeydown}
                                                    disabled={initialGlow || jobApplyFilterLoading}
                                                />
                                                {
                                                    superAdminJobSearch && !(initialGlow || jobApplyFilterLoading) ?
                                                        <div className='searchButtonClick-superAdmin ' title='Search' onClick={() => clickSearchIcon()}>
                                                            <IoIosSearch />
                                                        </div>
                                                        :
                                                        null
                                                }

                                                <div className='clearButtonClick-superAdmin' title='Clear' onClick={() => handle_clear_user_searches("search")}>
                                                    <MdClear />
                                                </div>
                                            </div>
                                    }
                                </div>

                                {/* filter modal  */}
                                <div className="col-12 col-sm-6 col-lg-12">
                                    {
                                        initialGlow ?
                                            <div className='placeholder w-100 rounded-2 py-3'></div>
                                            :
                                            <div className="card rounded-3 border-0 w-100">
                                                <div className="card-body p-0 cursorPointer">
                                                    <div className="d-flex flex-wrap align-items-center filter-closet py-2 w-100 " onClick={() => setEmployerOpen(!employerOpen)}>
                                                        <div className="col-2 col-lg-1 text-center p-0">
                                                            <IoFilterSharp className='fs-4 ' />
                                                        </div>
                                                        <div className="col-3">
                                                            <p className="mb-0 ps-2 w-100 superAdmin-filter-size-title">
                                                                Filter
                                                            </p>
                                                        </div>

                                                        {
                                                            isMilleSearchFiltered ?
                                                                <div className='col-7 col-lg-8 text-end'>
                                                                    <Button buttonType={"button"} className={"btn btn-transparent border border-brand-color px-3 py-1 me-3"}
                                                                        functionOnchange={() => handle_clear_user_searches("clear filter")}
                                                                        title={"Clear Filter"} />
                                                                </div>
                                                                :
                                                                null
                                                        }
                                                    </div>

                                                    <div className={`${employerOpen && !initialGlow && !jobApplyFilterLoading ? "employer-filter-box-superAdmin rounded-4 filter-closet shadow" : "d-none"}`}>
                                                        <div className="h-100">
                                                            <div className="d-flex flex-wrap align-items-center p-3 pb-2 pe-1 sticky-top border-bottom bg-white w-100 rounded-top-4">
                                                                <div className="col">
                                                                    <h6 className="m-0 fw-bold">Filter</h6>
                                                                </div>
                                                                <div className="col text-end pe-0">
                                                                    <button className="btn btn-sm border-0">
                                                                        <IoIosCloseCircleOutline
                                                                            className="fs-4"
                                                                            onClick={() => setEmployerOpen(!employerOpen)}
                                                                        />
                                                                    </button>
                                                                </div>
                                                            </div>

                                                            {/* employer-filter-box body */}
                                                            <SuperAdminJobFilter
                                                                employerJobType={employerJobType}
                                                                employerJobLocation={employerJobLocation}
                                                                employerJobSchedule={employerJobSchedule}
                                                                employerJobSector={employerJobSector}
                                                                employerJobSkill={employerJobSkill}
                                                                employerJobSpeci={employerJobSpeci}
                                                                employerJobWorkplace={employerJobWorkplace}
                                                                setEmployerOpen={setEmployerOpen}
                                                                setEmployerJobLocation={setEmployerJobLocation}
                                                                setEmployerJobSector={setEmployerJobSector}
                                                                setEmployerJobSkill={setEmployerJobSkill}
                                                                setEmployerJobSpeci={setEmployerJobSpeci}
                                                                setSortBy={setSortBy}
                                                                setjobsSortBy={setjobsSortBy}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                    }
                                </div>

                                {/* sorting  */}
                                <div className="col-12 col-sm-6 col-lg-12">
                                    {
                                        initialGlow ?
                                            <div className='placeholder w-100 rounded-2 py-3'></div>
                                            :
                                            <div className="dropdown employer-custom-dropdown">
                                                <button
                                                    className="btn dropdown-toggle w-100 filter-section d-flex flex-wrap align-items-center choose-dropdown"
                                                    type="button"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    <span className="fw-bold">Sort by:</span>
                                                    <span className="text-secondary ps-3">
                                                        {sortBy}
                                                    </span>
                                                </button>
                                                <ul className="dropdown-menu w-100 border-0 shadow">
                                                    <li className="dropdown-item p-2 ps-3" onClick={() => handleSortingFilter("Date Latest")}>
                                                        Date Latest
                                                    </li>
                                                    <li className="dropdown-item p-2 ps-3" onClick={() => handleSortingFilter("Date Oldest")}>
                                                        Date Oldest
                                                    </li>
                                                    <li className="dropdown-item p-2 ps-3" onClick={() => handleSortingFilter("A-Z")}>
                                                        A-Z
                                                    </li>
                                                    <li className="dropdown-item p-2 ps-3" onClick={() => handleSortingFilter("Z-A")}>
                                                        Z-A
                                                    </li>
                                                </ul>
                                            </div>
                                    }
                                </div>

                                <div className="col-12 col-sm-6 col-lg-12">
                                    {
                                        initialGlow || jobApplyFilterLoading ?
                                            <div className='placeholder w-100 rounded-2 py-3'></div>
                                            :
                                            <p className='showing-results text-secondary mb-0 py-2'>
                                                {
                                                    employerJobDetailsDupli.length > 0 ?
                                                        paginationTotalCount > 10 ?
                                                            // `Showing : ${(currentPage * 10) + 1}-${(currentPage * 10) + employerJobDetailsDupli.length} of ${formatNumber(paginationTotalCount)} jobs`
                                                            `Showing : ${(currentPage * 10) + 1}-${(currentPage * 10) + employerJobDetailsDupli.length} of ${paginationTotalCount} jobs`
                                                            :
                                                            `Showing : 1-${employerJobDetailsDupli.length} of ${employerJobDetailsDupli.length} jobs`
                                                        :
                                                        `Showing : 0 jobs`
                                                }
                                            </p>
                                    }
                                </div>
                            </div>

                            {/* candidates cards  */}
                            <div ref={containerRef} className={`${employerJobDetailsDupli.length > 0 ? "overflow-scroll" : ""} superAdmin-professional-cards `}>
                                <div className={`${employerJobDetailsDupli.length > 0 ? "" : "h-100"} d-flex flex-wrap align-content-stretch justify-content-between mb-2 pb-3`}>
                                    {
                                        initialGlow || jobApplyFilterLoading ?
                                            a.map((value, index) => {
                                                return (
                                                    <div className="card w-100 mb-2 rounded-2 border-0" key={index}>
                                                        <div className="card-body ">
                                                            <div className="d-flex align-items-center my-2">
                                                                <div className=" placeholder rounded-circle pe-none">
                                                                    <img
                                                                        src={""}
                                                                        width={52}
                                                                        height={52}
                                                                        className="opacity-0 d-block"
                                                                        alt="..."
                                                                    />
                                                                </div>
                                                                <div className="flex-grow-1 ms-3">
                                                                    <p className="job-card-posted-time placeholder col-5 rounded py-3"></p>
                                                                    <h6 className="job-card-component-heading placeholder col-8 rounded py-2 pt-3"></h6>
                                                                </div>
                                                            </div>
                                                            <div className="d-flex justify-content-between card-company-details-icon mt-4">
                                                                <label className="fs-7 card-inner-details col-3">
                                                                    <span className="placeholder rounded py-2 pt-3 w-100"></span>
                                                                </label>
                                                                <label className="fs-7 card-inner-details col-2">
                                                                    <span className="placeholder rounded py-2 pt-3 w-100"></span>
                                                                </label>
                                                                <label className="fs-7 card-inner-details col-2">
                                                                    <span className="placeholder rounded py-2 pt-3 w-100"></span>
                                                                </label>
                                                                <label className="fs-7 card-inner-details col-2">
                                                                    <span className="placeholder rounded py-2 pt-3 w-100"></span>
                                                                </label>
                                                            </div>
                                                            <p className="mt-4 job-card-description placeholder rounded skeleton-jobParagraph col-12">
                                                                {" "}
                                                            </p>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                            :
                                            employerJobDetailsDupli.length > 0 ?
                                                employerJobDetailsDupli.map((v, i) => {
                                                    return (
                                                        <div className="card w-100 mb-2 rounded-4 border-0" key={i}>
                                                            <div className="card-body">
                                                                <JobCard
                                                                    pricing_category={v.is_active === "Y" ?
                                                                        v.pricing_category === "Basic" && v.payment_status === "trialing" ?
                                                                            "trialing"
                                                                            :
                                                                            v.pricing_category
                                                                        :
                                                                        "canceled"
                                                                    }
                                                                    company_name={v.company_name}
                                                                    profile_image={v.profile_image}
                                                                    jobHeading={v.job_title}
                                                                    postedOn={v.created_at}
                                                                    workplace={v.workplace_type}
                                                                    city={v.job_city}
                                                                    schedule={v.work_schedule}
                                                                    jobType={v.job_type}
                                                                    payment={v.is_paid}
                                                                    cardDesc={v.job_overview}
                                                                    jobId={v.id}
                                                                    selectedJobCard={selectedJobCard}
                                                                    notes={v.custom_notes}
                                                                    recom_jobs={v.recommended_professional}
                                                                    jobSts={v.job_status}
                                                                />
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                                :
                                                <div className="col-12 h-75 row align-items-center justify-content-center">
                                                    <img src={images.noRecordsFound} className="sprAdmin-NoRecord-img" alt="no data found" />
                                                </div>
                                    }


                                </div>
                                {
                                    initialGlow || jobApplyFilterLoading ?
                                        <div className="col-12 row justify-content-center">
                                            <div className="col-10 placeholder rounded-2 py-3"></div>
                                        </div>
                                        :
                                        paginationTotalCount > 10 ?
                                            <div className="mb-5 col-12">
                                                <SuperAdminPagination />
                                            </div>
                                            :
                                            null
                                }
                            </div>
                        </div>

                        {/* job detail view  */}
                        <div className="col-7 col-lg-8 py-3 h-100">
                            <JobDetailView />
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default SuperAdminJobs